import { SPage } from "servisofts-component";
import Model from "../../../Model/";
import root from "./root";
import tbven from "./tbven";
export default SPage.combinePages("profile", {
    "": root,
    tbven

})
